import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useTheme } from '../context/ThemeContext';
import { useAuth } from '../context/AuthContext';
import Button from '../components/Button';
import Icon from '../components/Icon';

export const ONBOARDING_KEY = 'onboarding_seen';

export default function Onboarding() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { colors } = useTheme();
  const { enterGuest } = useAuth();
  const go = (path: string) => {
    try { localStorage.setItem(ONBOARDING_KEY, '1'); } catch { /* Storage may be unavailable. */ }
    navigate(path);
  };
  const browse = () => {
    try { localStorage.setItem(ONBOARDING_KEY, '1'); } catch { /* Storage may be unavailable. */ }
    enterGuest();
    navigate('/home');
  };

  return (
    <main style={{ minHeight: '100dvh', display: 'flex', alignItems: 'center', background: colors.bg, padding: 'calc(24px + env(safe-area-inset-top, 0px)) 24px calc(24px + env(safe-area-inset-bottom, 0px))' }}>
      <div style={{ width: '100%', maxWidth: 440, margin: '0 auto', textAlign: 'center' }}>
        <img src="/icons/icon-512.png" alt="SL Sweep" style={{ width: 88, height: 88 }} />
        <h1 style={{ margin: '24px 0 8px', fontSize: 28, fontWeight: 700 }}>{t('auth.onboarding.welcomeTitle')}</h1>
        <p style={{ margin: '0 auto 28px', maxWidth: 360, color: colors.textSub, fontSize: 17, lineHeight: 1.5 }}>{t('auth.onboarding.welcomeBody')}</p>
        <div style={{ display: 'grid', gap: 12, textAlign: 'left', marginBottom: 28 }}>
          {(['browse', 'funds', 'control'] as const).map(key => (
            <div key={key} style={{ display: 'flex', gap: 12, alignItems: 'center' }}>
              <span style={{ width: 40, height: 40, borderRadius: 20, background: colors.accentSoft, display: 'grid', placeItems: 'center', flexShrink: 0 }}><Icon name="check" size={15} color={colors.accent} /></span>
              <span style={{ fontSize: 16, lineHeight: 1.4 }}>{t(`auth.onboarding.points.${key}`)}</span>
            </div>
          ))}
        </div>
        <Button label={t('auth.onboarding.createAccount')} onClick={() => go('/register')} />
        <Button label={t('auth.onboarding.signIn')} variant="secondary" onClick={() => go('/login')} style={{ marginTop: 10 }} />
        <Button label={t('auth.onboarding.explore')} variant="text" onClick={browse} style={{ marginTop: 8 }} />
      </div>
    </main>
  );
}
